import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import {
	appleLoginRequest,
	clearLoginPendingConfirmation,
	facebookLoginRequest,
	googleLoginRequest,
	loginRequest,
	PendingLoginConfirmation,
} from '../../../../store/auth/authActions';
import RedesignConfirmModal from '../RedesignConfirmModal';

interface SessionConfirmationModalProps {
	visible: boolean;
	onClose: () => void;
	pendingConfirmation: PendingLoginConfirmation;
}

function SessionConfirmationModal({
	visible,
	onClose,
	pendingConfirmation,
}: SessionConfirmationModalProps) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	if (!visible) return null;

	const handleDeny = () => {
		dispatch(clearLoginPendingConfirmation());
		onClose();
	};

	const handleAccept = () => {
		if (pendingConfirmation.type === 'password') {
			dispatch(
				loginRequest({
					username: pendingConfirmation.username,
					password: pendingConfirmation.password,
					confirmed: true,
				}),
			);
		} else if (pendingConfirmation.type === 'apple') {
			dispatch(
				appleLoginRequest({
					idToken: pendingConfirmation.idToken,
					confirmed: true,
				}),
			);
		} else if (pendingConfirmation.type === 'facebook') {
			dispatch(
				facebookLoginRequest({
					idToken: pendingConfirmation.idToken,
					confirmed: true,
				}),
			);
		} else {
			dispatch(
				googleLoginRequest({
					idToken: pendingConfirmation.idToken,
					confirmed: true,
				}),
			);
		}

		onClose();
	};

	return (
		<RedesignConfirmModal
			message={t('T_SITE_MODAL_LOGIN_CONFIRMATION')}
			cancelLabel={t('T_SITE_DENY') || 'Deny'}
			confirmLabel={t('T_SITE_ACCEPT') || 'Accept'}
			onCancel={handleDeny}
			onConfirm={handleAccept}
			cancelTestId='cta-session-deny'
			confirmTestId='cta-session-accept'
		/>
	);
}

export default SessionConfirmationModal;
